<template>
  <div class="row p-0">
    <div class="col-12">
      <div class="container mt-2 mb-4" v-show="!printing">
        <div class="col-12 text-center">
          <h4 slot="header" class="card-title">Cartão de Ponto</h4>
        </div>
        <div class="row">
          <div class="col d-flex flex-row align-items-center">
            <div class="faltas"></div>
            Faltas
          </div>
          <div class="col d-flex flex-row align-items-center">
            <div class="feriados"></div>
            Feriados
          </div>
          <div class="col d-flex flex-row align-items-center">
            <div class="ferias"></div>
            Férias/Afastamentos
          </div>
          <div class="col d-flex flex-row align-items-center">
            <div class="folgas"></div>
            Folga
          </div>
          <div class="col d-flex flex-row align-items-center">
            <div class="batidas">*</div>
            Batidas Manuais
          </div>
        </div>
      </div>

      <div
        class="container rounded"
        style="background: #f9f9f9; padding: 0 3rem;"
      >
        <div class="row" style="padding: 0 1rem;">
          <div class="col-6">
            <div class="row">
              <div class="col text-left texto-cabecalho">
                EMPRESA:
                {{
                  dados.dadosEmpregado.empresa
                    ? dados.dadosEmpregado.empresa
                    : "-"
                }}
              </div>
            </div>
            <div class="row">
              <div class="col text-left texto-cabecalho">
                CNPJ:
                {{
                  dados.dadosEmpregado.cnpj
                    ? formatarCpfCnpj(dados.dadosEmpregado.cnpj)
                    : "-"
                }}
              </div>
            </div>
            <div class="row">
              <div class="col text-left texto-cabecalho">
                I. E.: I. M.:
                {{ dados.dadosEmpregado.ie ? dados.dadosEmpregado.ie : "-" }}
              </div>
            </div>
            <div class="row">
              <div class="col text-left texto-cabecalho">
                ENDEREÇO:
                {{
                  dados.dadosEmpregado.endereco
                    ? dados.dadosEmpregado.endereco
                    : "-"
                }}
              </div>
            </div>
            <div class="row">
              <div class="col text-left texto-cabecalho">
                COMP.:
                {{
                  dados.dadosEmpregado.comp ? dados.dadosEmpregado.comp : "-"
                }}. BAIRRO:
                {{
                  dados.dadosEmpregado.bairro
                    ? dados.dadosEmpregado.bairro
                    : "-"
                }}
                CIDADE:
                {{
                  dados.dadosEmpregado.cidade
                    ? dados.dadosEmpregado.cidade
                    : "-"
                }}
              </div>
            </div>
            <div class="row">
              <div class="col text-left texto-cabecalho">
                EMPREGADO:
                {{
                  dados.dadosEmpregado.empregado
                    ? dados.dadosEmpregado.empregado
                    : "-"
                }}
              </div>
            </div>
            <div class="row">
              <div class="col text-left texto-cabecalho">
                PIS/PASEP:
                {{
                  dados.dadosEmpregado.pisPasep
                    ? dados.dadosEmpregado.pisPasep
                    : "-"
                }}
                CTPS:
                {{
                  dados.dadosEmpregado.ctps ? dados.dadosEmpregado.ctps : "-"
                }}
              </div>
            </div>
            <div class="row">
              <div class="col text-left texto-cabecalho">
                CPF:
                {{
                  dados.dadosEmpregado.cpf
                    ? formatarCpfCnpj(dados.dadosEmpregado.cpf)
                    : "-"
                }}. Matrícula:
                {{
                  dados.dadosEmpregado.matricula
                    ? dados.dadosEmpregado.matricula
                    : "-"
                }}
              </div>
            </div>
            <div class="row">
              <div class="col text-left texto-cabecalho">
                DEPARTAMENTO:
                {{
                  dados.dadosEmpregado.departamento
                    ? dados.dadosEmpregado.departamento
                    : "-"
                }}<br />
                FUNÇÃO:
                {{
                  dados.dadosEmpregado.funcao
                    ? dados.dadosEmpregado.funcao
                    : "-"
                }}
              </div>
            </div>
            <div class="row">
              <div class="col text-left texto-cabecalho">
                Posto de Trabalho:
                {{ dados.dadosEmpregado.posto }}<br />
                PERÍODO:
                {{ moment(periodo.de).format("DD/MM/YYYY") }} até
                {{ moment(periodo.ate).format("DD/MM/YYYY") }}
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="row text-left texto-cabecalho">
              <p style="padding: 0;">
                <b>Modo de cálculo:</b>
                {{ dados.config.deducao ? "Flexível" : "Rígido" }}.
                <b>Tolerância:</b>
                {{ dados.config.tolerancia }}
              </p>
            </div>
            <div
              class="row text-left texto-cabecalho"
              v-if="dados.escalas.departamento.length > 0"
            >
              ESCALAS:
              <div
                v-for="item in dados.escalas.departamento"
                :key="dados.dadosEmpregado.id + '-esc-' + item.id"
              >
                <p class="texto-cabecalho">
                  {{ item.descricao }} -
                  {{
                    item.entrada_1 ? moment(item.entrada_1).format("HH:mm") : ""
                  }}
                  {{ item.saida_1 ? moment(item.saida_1).format("HH:mm") : "" }}
                  {{
                    item.entrada_2 ? moment(item.entrada_2).format("HH:mm") : ""
                  }}
                  {{ item.saida_2 ? moment(item.saida_2).format("HH:mm") : "" }}
                  {{
                    item.entrada_3 ? moment(item.entrada_3).format("HH:mm") : ""
                  }}
                  {{ item.saida_3 ? moment(item.saida_3).format("HH:mm") : "" }}
                  {{
                    item.entrada_4 ? moment(item.entrada_4).format("HH:mm") : ""
                  }}
                  {{ item.saida_4 ? moment(item.saida_4).format("HH:mm") : "" }}
                  {{ ` Jornada ${item.horas}` }}
                  {{ item.dias ? "- " + item.dias : "" }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th scope="col">Dia Semana</th>
                <th scope="col">Hor.</th>
                <th scope="col">Ent1</th>
                <th scope="col">{{ getLabelPreAssin("Saí1") }}</th>
                <th scope="col">{{ getLabelPreAssin("Ent2") }}</th>
                <th scope="col">{{ getLabelPreAssin("Saí2") }}</th>
                <th scope="col">{{ getLabelPreAssin("Ent3") }}</th>
                <th scope="col">{{ getLabelPreAssin("Saí3") }}</th>
                <th scope="col">{{ getLabelPreAssin("Ent4") }}</th>
                <th scope="col">Saí4</th>
                <th scope="col">H.Exerc</th>
                <th v-show="dados.config.intrajornada" scope="col">Intraj.</th>
                <th scope="col">H.Atraso (-)</th>
                <th scope="col">
                  {{ dados.config.bancoHora ? "B.Horas (+)" : "H.Extras (+)" }}
                </th>
                <th scope="col">Adic/Notur</th>
                <th scope="col">H.Abono</th>
                <th v-show="!printing && !modoVisualizacao" scope="col">
                  Abon./Ocorr.
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dados.horarios"
                :key="dados.dadosEmpregado.id + '-hrs-' + item.data"
                :class="selecionaStatus(item)"
              >
                <th>
                  <p class="m-0 p-0">{{ selecionaLabelDia(item) }}</p>
                </th>
                <th>
                  <p class="m-0 p-0">{{ item.escala }}</p>
                </th>
                <th
                  role="button"
                  @click="
                    !modoVisualizacao
                      ? abrirModalBatidaManual(
                          item.dadosBatidas[0] || item.day,
                          dados.dadosEmpregado.matricula
                        )
                      : null
                  "
                >
                  <p class="m-0 p-0">
                    {{
                      item.batidas.length >= 1
                        ? gerarLabelHorario(item.dadosBatidas[0])
                        : ""
                    }}
                  </p>
                </th>
                <th
                  role="button"
                  @click="
                    !modoVisualizacao
                      ? abrirModalBatidaManual(
                          item.dadosBatidas[1] || item.day,
                          dados.dadosEmpregado.matricula
                        )
                      : null
                  "
                >
                  <p class="m-0 p-0">
                    {{
                      item.batidas.length >= 2
                        ? gerarLabelHorario(item.dadosBatidas[1])
                        : ""
                    }}
                  </p>
                </th>
                <th
                  role="button"
                  @click="
                    !modoVisualizacao
                      ? abrirModalBatidaManual(
                          item.dadosBatidas[2] || item.day,
                          dados.dadosEmpregado.matricula
                        )
                      : null
                  "
                >
                  <p class="m-0 p-0">
                    {{
                      item.batidas.length >= 3
                        ? gerarLabelHorario(item.dadosBatidas[2])
                        : ""
                    }}
                  </p>
                </th>
                <th
                  role="button"
                  @click="
                    !modoVisualizacao
                      ? abrirModalBatidaManual(
                          item.dadosBatidas[3] || item.day,
                          dados.dadosEmpregado.matricula
                        )
                      : null
                  "
                >
                  <p class="m-0 p-0">
                    {{
                      item.batidas.length >= 4
                        ? gerarLabelHorario(item.dadosBatidas[3])
                        : ""
                    }}
                  </p>
                </th>
                <th
                  role="button"
                  @click="
                    !modoVisualizacao
                      ? abrirModalBatidaManual(
                          item.dadosBatidas[4] || item.day,
                          dados.dadosEmpregado.matricula
                        )
                      : null
                  "
                >
                  <p class="m-0 p-0">
                    {{
                      item.batidas.length >= 5
                        ? gerarLabelHorario(item.dadosBatidas[4])
                        : ""
                    }}
                  </p>
                </th>
                <th
                  role="button"
                  @click="
                    !modoVisualizacao
                      ? abrirModalBatidaManual(
                          item.dadosBatidas[5] || item.day,
                          dados.dadosEmpregado.matricula
                        )
                      : null
                  "
                >
                  <p class="m-0 p-0">
                    {{
                      item.batidas.length >= 6
                        ? gerarLabelHorario(item.dadosBatidas[5])
                        : ""
                    }}
                  </p>
                </th>
                <th
                  role="button"
                  @click="
                    !modoVisualizacao
                      ? abrirModalBatidaManual(
                          item.dadosBatidas[6] || item.day,
                          dados.dadosEmpregado.matricula
                        )
                      : null
                  "
                >
                  <p class="m-0 p-0">
                    {{
                      item.batidas.length >= 7
                        ? gerarLabelHorario(item.dadosBatidas[6])
                        : ""
                    }}
                  </p>
                </th>
                <th
                  role="button"
                  @click="
                    !modoVisualizacao
                      ? abrirModalBatidaManual(
                          item.dadosBatidas[7] || item.day,
                          dados.dadosEmpregado.matricula
                        )
                      : null
                  "
                >
                  <p class="m-0 p-0">
                    {{
                      item.batidas.length >= 8
                        ? gerarLabelHorario(item.dadosBatidas[7])
                        : ""
                    }}
                  </p>
                </th>
                <th>
                  <p class="m-0 p-0">{{ item.exercidas }}</p>
                </th>
                <th
                  v-show="dados.config.intrajornada"
                  :class="
                    item.intrajornada != '00:00' ? 'cell-intrajornada' : ''
                  "
                >
                  <p class="m-0 p-0">{{ item.intrajornada }}</p>
                </th>
                <th :class="item.atrasos != '00:00' ? 'cell-atraso' : ''">
                  <p class="m-0 p-0">{{ item.atrasos }}</p>
                </th>
                <th :class="item.extras != '00:00' ? 'cell-extra' : ''">
                  <p class="m-0 p-0">{{ item.extras }}</p>
                </th>
                <th :class="item.noturno != '00:00' ? 'cell-noturno' : ''">
                  <p class="m-0 p-0">{{ item.noturno }}</p>
                </th>
                <th :class="item.abonos != '00:00' ? 'cell-abono' : ''">
                  <p class="m-0 p-0">{{ item.abonos }}</p>
                </th>
                <td v-show="!printing && !modoVisualizacao">
                  <el-tooltip
                    content="Adicionar Abono"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      class="remove btn-link"
                      type="success"
                      size="sm"
                      icon
                      @click="abrirModalAbono(item)"
                    >
                      <i class="tim-icons icon-simple-add"></i>
                    </base-button>
                  </el-tooltip>
                  <el-tooltip
                    content="Adicionar Ocorrência"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      class="remove btn-link"
                      type="warning"
                      size="sm"
                      icon
                      @click="abrirModalOcorrencia(item)"
                    >
                      <i class="tim-icons icon-alert-circle-exc"></i>
                    </base-button>
                  </el-tooltip>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-responsive">
          <h4 class="mt-0">Resumo do mês</h4>
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th scope="col">Faltas</th>
                <th scope="col">Horas Exercidas</th>
                <th scope="col" v-show="dados.config.intrajornada">
                  Intrajornada
                </th>
                <th scope="col">Horas Atrasadas</th>
                <th scope="col">
                  {{ dados.config.labelExtra50 || "Extras 50%" }}
                </th>
                <th scope="col">
                  {{ dados.config.labelExtra100 || "Extras 100%" }}
                </th>
                <th scope="col">Adc Noturno</th>
                <th scope="col">Abonos</th>
                <th scope="col">DSR</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ dados.totais.faltasDias }}</td>
                <td>{{ dados.totais.exercidas }}</td>
                <td v-show="dados.config.intrajornada">
                  {{ dados.totais.intrajornada }}
                </td>
                <td>{{ dados.totais.atrasos }}</td>
                <td>{{ dados.totais.extras }}</td>
                <td>{{ dados.totais.extras100 }}</td>
                <td>{{ dados.totais.noturno }}</td>
                <td>{{ dados.totais.abonos }}</td>
                <td>{{ dados.totais.dsr }}</td>
              </tr>
            </tbody>

            <thead v-if="dados.config.bancoHora">
              <tr>
                <th scope="col">Saldo Inicial</th>
                <th scope="col">Crédito</th>
                <th scope="col">Débito</th>
                <th scope="col">Saldo em Banco de Horas</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody v-if="dados.config.bancoHora">
              <tr>
                <td>{{ dados.bancoHora.labelInicial }}</td>
                <td>{{ dados.bancoHora.labelCredito }}</td>
                <td>{{ dados.bancoHora.labelDebito }}</td>
                <td>{{ dados.bancoHora.labelSaldo }}</td>
                <td colspan="4"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="table-responsive"
          v-if="
            (!printing && dados.abonos.length > 0) ||
              (dados.abonos.length > 0 &&
                printing &&
                dados.config.imprimirAbono == '1')
          "
        >
          <h4 class="mt-0">Resumo de Abonos</h4>
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th scope="col">Data</th>
                <th scope="col">Descrição</th>
                <th scope="col">Horas</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dados.abonos"
                :key="dados.dadosEmpregado.id + '-abs-' + item.id"
              >
                <td>{{ moment(item.data).format("DD/MM/YYYY") }}</td>
                <td>{{ item.descricao }}</td>
                <td>
                  {{ moment(`${item.data} ${item.hora}`).format("HH:mm") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          class="table-responsive"
          v-if="
            (!printing && dados.afastamentos.length > 0) ||
              (dados.afastamentos.length > 0 && printing)
          "
        >
          <h4 class="mt-0">Resumo de Afastamentos</h4>
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th scope="col">Período</th>
                <th scope="col">Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dados.afastamentos"
                :key="dados.dadosEmpregado.id + '-afas-' + item.id"
              >
                <td>
                  {{
                    `${moment(item.data_inicial).format("DD/MM/YYYY")} -
                  ${moment(item.data_final).format("DD/MM/YYYY")}`
                  }}
                </td>
                <td>{{ item.descricao }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          class="table-responsive"
          v-if="
            (!printing &&
              dados.abonosBH.length > 0 &&
              dados.config.bancoHora) ||
              (dados.abonosBH.length > 0 &&
                dados.config.bancoHora &&
                printing &&
                dados.config.imprimirAbonoBH == '1')
          "
        >
          <h4 class="mt-0">Resumo de Abonos de Banco de Horas</h4>
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th scope="col">Data</th>
                <th scope="col">Descrição</th>
                <th scope="col">Horas</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dados.abonosBH"
                :key="dados.dadosEmpregado.id + '-absh-' + item.id"
              >
                <td>{{ item.dataFormatada }}</td>
                <td>{{ item.descricao }}</td>
                <td>{{ item.horas }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          class="table-responsive"
          v-if="
            (!printing && dados.ocorrencias.length > 0) ||
              (dados.ocorrencias.length > 0 &&
                printing &&
                dados.config.imprimirOcorrencia == '1')
          "
        >
          <h4 class="mt-0">Resumo de Ocorrências</h4>
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th scope="col">Data</th>
                <th scope="col">Título</th>
                <th scope="col">Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dados.ocorrencias"
                :key="dados.dadosEmpregado.id + '-oco-' + item.id"
              >
                <td>{{ moment(item.data).format("DD/MM/YYYY") }}</td>
                <td>{{ item.titulo }}</td>
                <td>{{ item.descricao }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          class="table-responsive"
          v-if="
            (!printing &&
              dados.batidasManuais.length > 0 &&
              dados.config.batidaManual == 1) ||
              (dados.batidasManuais.length > 0 &&
                dados.config.batidaManual == 1 &&
                printing &&
                dados.config.imprimirBatidasManuais == '1')
          "
        >
          <h4 class="mt-0">Resumo Batidas Manuais</h4>
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th scope="col">Data</th>
                <th scope="col">Hora Manual</th>
                <th scope="col">Registro Original</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dados.batidasManuais"
                :key="dados.dadosEmpregado.id + '-bm-' + item.id"
              >
                <td>{{ moment(item.data).format("DD/MM/YYYY") }}</td>
                <td>{{ item.hora }}</td>
                <td>
                  {{
                    item.dt_anterior
                      ? moment(item.dt_anterior).format("HH:mm")
                      : ""
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="m-0" v-show="printing">
          <div class="row text-left texto-cabecalho">
            <p class="col-12 texto-cabecalho">
              Conheço como verdadeiro meus horários de entrada e sáida contidos
              neste relatório.<br />
              Como responsável, reconheço como verdadeiro os horários de entrada
              e saída do funcionário. <br />
            </p>

            <div class="col-5 border-top text-center pt-1 mt-3">
              {{ dados.dadosEmpregado.empresa }}
            </div>

            <div class="col-5 offset-2 border-top text-center pt-1 mt-3">
              {{ dados.dadosEmpregado.empregado }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>

    <!--So abre o modal se tiver configurado no banco para fazer batida manual-->
    <modal :show.sync="modalBatidaManual && dados.config.batidaManual == 1">
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          Batida Manual
        </h4>
      </template>

      <div class="p-3">
        <div class="row">
          <span v-if="postos.length == 0" class="text-danger"
            >Não é possível registrar batida manual, autorize um posto de
            trabalho para continuar</span
          >

          <el-select
            v-if="postos.length > 1"
            class="select-success mb-3 pagination-select"
            :class="erros.empregador === true ? 'has-danger' : ''"
            placeholder="Selecione um posto de trabalho"
            v-model="dataBatidaManual.id_empregador"
          >
            <el-option
              class="select-success"
              v-for="item in postos"
              :key="
                `${String(item.CPF_EMPREGADO)}${String(item.ID_EMPREGADOR)}`
              "
              :value="item.ID_EMPREGADOR"
              :label="item.DS_LOCAL"
              >{{ item.DS_LOCAL }}
            </el-option>
          </el-select>

          <base-input
            label="Data:"
            class="col-12 text-left"
            :class="erros.data === true ? 'has-danger' : ''"
            type="date"
            v-model="dataBatidaManual.data_batida"
          >
          </base-input>

          <base-input
            label="Hora:"
            class="col-12 text-left"
            :class="erros.hora === true ? 'has-danger' : ''"
            type="time"
            v-model="dataBatidaManual.hora_batida"
          >
          </base-input>
        </div>
      </div>
      <template slot="footer">
        <base-button type="danger" @click="modalBatidaManual = false"
          >Fechar</base-button
        >
        <base-button type="success" @click="cadastrarBatidaManual()"
          >Salvar</base-button
        >
      </template>
    </modal>

    <modal :show.sync="modalAbonoManual">
      <AbonosInserir
        v-if="modalAbonoManual"
        :dados="dataAbono.data"
        :funcionario="dataAbono.funcionario"
        :config="dados.config"
        @fecharModalAbono="fecharModalAbono"
      />
    </modal>

    <modal :show.sync="modalOcorrencia">
      <OcorrenciasInserir
        v-if="modalOcorrencia"
        :dados="dataOcorrencia.data"
        :funcionario="dataOcorrencia.funcionario"
        @fecharModalOcorrencia="fecharModalOcorrencia"
      />
    </modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { BaseInput, AbonosInserir, OcorrenciasInserir } from "./index";
import { Select, Option } from "element-ui";
import Modal from "@/components/Modal.vue";
import swal from "sweetalert2";
import moment from "moment";

export default {
  name: "BaseCartaoPonto",
  components: {
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseInput,
    Modal,
    AbonosInserir,
    OcorrenciasInserir,
  },
  props: {
    dados: Object,
    periodo: Object,
    printing: Boolean,
    modoVisualizacao: Boolean,
  },
  data() {
    return {
      isLoading: false,
      modalAbonoManual: false,
      modalBatidaManual: false,
      modalOcorrencia: false,
      postos: Array,
      dataBatidaManual: {
        data_batida: "",
        hora_batida: "",
        id_empregador: "",
        dt_anterior: "",
        id: "",
        matricula: "",
      },
      dataAbono: {
        data: String,
        funcionario: String,
      },
      dataOcorrencia: {
        data: String,
        funcionario: String,
      },
      erros: {
        data: "",
        hora: "",
        empregador: "",
      },
    };
  },
  mounted() {},
  methods: {
    getLabelPreAssin(headerLabel) {
      if (this.dados.dadosEmpregado.assinalacao == "sim") {
        if (
          headerLabel == "Saí1" &&
          this.dados.dadosEmpregado.preassi1 == "1"
        ) {
          return "Pré-Assi Saí1";
        }
        if (
          headerLabel == "Ent2" &&
          this.dados.dadosEmpregado.preassi1 == "1"
        ) {
          return "Pré-Assi Ent2";
        }
        if (
          headerLabel == "Saí2" &&
          this.dados.dadosEmpregado.preassi2 == "1"
        ) {
          return "Pré-Assi Saí2";
        }
        if (
          headerLabel == "Ent3" &&
          this.dados.dadosEmpregado.preassi2 == "1"
        ) {
          return "Pré-Assi Ent3";
        }
        if (
          headerLabel == "Saí3" &&
          this.dados.dadosEmpregado.preassi3 == "1"
        ) {
          return "Pré-Assi Saí3";
        }
        if (
          headerLabel == "Ent4" &&
          this.dados.dadosEmpregado.preassi3 == "1"
        ) {
          return "Pré-Assi Ent4";
        }
      }
      return headerLabel;
    },
    limparModal() {
      this.dataBatidaManual.data_batida = "";
      this.dataBatidaManual.hora_batida = "";
      this.dataBatidaManual.id_empregador = "";
      this.dataBatidaManual.id = "";
      this.dataBatidaManual.dt_anterior = "";
      this.dataBatidaManual.matricula = "";
    },
    limparErrosModal() {
      this.erros = {
        data: "",
        hora: "",
        empregador: "",
      };
    },
    verificarErroModalBatida() {
      if (this.dataBatidaManual.data_batida == "") {
        this.erros.data = true;
      } else {
        this.erros.data = false;
      }

      if (this.dataBatidaManual.hora_batida == "") {
        this.erros.hora = true;
      } else {
        this.erros.hora = false;
      }

      if (!this.dataBatidaManual.id_empregador) {
        this.erros.empregador = true;
      } else {
        this.erros.empregador = false;
      }
    },
    formatarCpfCnpj(valor) {
      if (valor.length === 14) {
        valor = valor.padStart(14, "0");
        valor = valor.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      } else {
        valor = valor.padStart(11, "0");
        valor = valor.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }

      return valor;
    },
    selecionaLabelDia(item) {
      const { faltou, folga, feriado, afastamento } = item;
      if (faltou) return `${item.data} - FA`;
      else if (afastamento) return item.data;
      else if (feriado) return `${item.data} - FE`;
      else if (folga) return `${item.data} - FO`;
      else return item.data;
    },
    selecionaStatus(item) {
      const { faltou, folga, feriado, afastamento } = item;
      if (faltou) return "tb-falta";
      else if (afastamento) return "tb-ferias";
      else if (feriado) return "tb-feriados";
      else if (folga) return "tb-folgas";
      else return "";
    },
    gerarLabelHorario(dados) {
      if (dados.tipoBatida == 3) {
        return `${moment(`${dados.data} ${dados.hora}`).format("HH:mm")}*`;
      } else {
        return `${moment(`${dados.data} ${dados.hora}`).format("HH:mm")}`;
      }
    },
    moment: function(data) {
      return moment(data);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    // APIS
    listarPostosFuncionario() {
      const th = this;
      const bodyFormData = {
        cpf_empregado: this.dados.dadosEmpregado.cpf,
      };

      if (!bodyFormData.cpf_empregado) {
        return;
      }
      this.axios
        .post("/api/login/loginEmpregadoApenasCpf", bodyFormData)
        .then((response) => {
          if (response.data.data.dados && response.data.data.dados.length > 0) {
            th.postos = response.data.data.dados;
            if (response.data.data.dados.length == 1) {
              //coloca direto no campo
              th.dataBatidaManual.id_empregador =
                response.data.data.dados[0].ID_EMPREGADOR;
            }
          }
        })
        .catch((err) => {
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar postos de trabalho!",
            "error"
          );
        });
    },
    cadastrarBatidaManual() {
      const th = this;
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_empregados: this.dados.dadosEmpregado.id,
        data_batida: this.dataBatidaManual.data_batida,
        hora_batida: this.dataBatidaManual.hora_batida,
        id_empregador: this.dataBatidaManual.id_empregador,
        id: this.dataBatidaManual.id || null,
        dt_anterior: this.dataBatidaManual.dt_anterior || null,
        matricula: this.dataBatidaManual.matricula || null,
      };
      if (
        bodyFormData.data_batida != "" &&
        bodyFormData.hora_batida != "" &&
        bodyFormData.id_empregador
      ) {
        this.isLoading = true;
        this.axios
          .post("/api/movimentacoes/baterPontoManual", bodyFormData)
          .then((response) => {
            th.isLoading = false;
            th.modalBatidaManual = false;
            if (response.data.data.status) {
              //batida com sucesso
              th.showSwal(
                "auto-close",
                "Sucesso",
                "Batida manual realizada com sucesso!",
                "success"
              );
              th.atualizarTable();
            } else {
              th.showSwal(
                "auto-close",
                "Erro",
                "Erro ao inserir batida manual!",
                "error"
              );
            }
          })
          .catch((err) => {
            console.log(err);
            th.isLoading = false;
            th.modalBatidaManual = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao inserir batida manual!",
              "error"
            );
          });
      } else {
        this.verificarErroModalBatida();
      }
    },
    // Modais
    async abrirModalBatidaManual(data, matricula) {
      this.limparModal();
      this.limparErrosModal();
      await this.listarPostosFuncionario();
      this.modalBatidaManual = true;
      if (typeof data == "object") {
        this.dataBatidaManual.data_batida = data.data;
        this.dataBatidaManual.hora_batida = data.hora;
        this.dataBatidaManual.id_empregador = data.id_empregador;
        this.dataBatidaManual.id = data.id;
        this.dataBatidaManual.matricula = data.matricula;
        if (data.id) {
          this.dataBatidaManual.dt_anterior = moment(
            `${data.data} ${data.hora}`
          ).format("YYYY-MM-DD HH:mm:ss");
        }
      } else {
        this.dataBatidaManual.data_batida = data;
        this.dataBatidaManual.matricula = matricula;
      }
    },
    abrirModalAbono(item) {
      this.dataAbono.data = item;
      this.dataAbono.funcionario = this.dados.dadosEmpregado.id;
      this.modalAbonoManual = true;
    },
    fecharModalAbono(atualizar) {
      this.modalAbonoManual = false;
      if (atualizar) {
        this.atualizarTable();
      }
    },
    abrirModalOcorrencia(item) {
      this.dataOcorrencia.data = item;
      this.dataOcorrencia.funcionario = this.dados.dadosEmpregado.id;
      this.modalOcorrencia = true;
    },
    fecharModalOcorrencia(atualizar) {
      this.modalOcorrencia = false;
      if (atualizar) {
        this.atualizarTable();
      }
    },
    atualizarTable() {
      this.$emit("atualizarTable", true);
    },
  },
};
</script>
<style>
.cell-atraso {
  background-color: #fa8072 !important;
}

.cell-extra {
  background-color: #00ff7f !important;
}

.cell-noturno {
  background-color: #daa520 !important;
}

.cell-abono {
  background-color: #ffdead !important;
}

.cell-intrajornada {
  background-color: #f8f8ff !important;
}

.faltas {
  width: 25px;
  height: 20px;
  background: #db6153;
  border-radius: 7px 7px 7px 7px;
  -moz-border-radius: 7px 7px 7px 7px;
  -webkit-border-radius: 7px 7px 7px 7px;
  border: none;
  margin-right: 5px;
}

.tb-falta {
  background: #db6153;
}

.tb-feriados {
  background: #e37acc;
}

.tb-folgas {
  background: #6ece87;
}

.tb-ferias {
  background: #7a93e3;
}

.feriados {
  width: 25px;
  height: 20px;
  background: #e37acc;
  border-radius: 7px 7px 7px 7px;
  -moz-border-radius: 7px 7px 7px 7px;
  -webkit-border-radius: 7px 7px 7px 7px;
  border: none;
  margin-right: 5px;
}

.ferias {
  width: 25px;
  height: 20px;
  background: #7a93e3;
  border-radius: 7px 7px 7px 7px;
  -moz-border-radius: 7px 7px 7px 7px;
  -webkit-border-radius: 7px 7px 7px 7px;
  border: none;
  margin-right: 5px;
}

.folgas {
  width: 25px;
  height: 20px;
  background: #6ece87;
  border-radius: 7px 7px 7px 7px;
  -moz-border-radius: 7px 7px 7px 7px;
  -webkit-border-radius: 7px 7px 7px 7px;
  border: none;
  margin-right: 5px;
}

.batidas {
  margin-right: 5px;
}
</style>
